import Button from "@metacrm/metacrm-material-ui/dist/Button";
import { Box } from "@mui/material";
import useGetPagePermission from "hooks/useGetPagePermission";
import React from "react";
import { useIntl } from "react-intl";

export default function EmptyImgStatus({
  img,
  type = "tracking",
  backgroundImg,
  height,
  title,
  description,
  buttonText,
  onClick,
  showButton,
  sx,
}) {
  const { formatMessage } = useIntl();
  const pagePermission = useGetPagePermission();

  const trackingWording = {
    img: img || "tracking",
    title: title || "No trackings found",
    description:
      description ||
      formatMessage({
        id: "emptyState.attributionNeedTrackingTag.description",
      }),
    buttonText:
      buttonText ||
      formatMessage({ id: "emptyState.trackingTagNotInstalled.btn" }),
    onClick: onClick || null,
    showButton: showButton || pagePermission("integration").canEdit,
  };

  const integrateWording = {
    img: img || "tracking",
    title: title || "Not Integrated",
    description:
      description ||
      "Complete Discord Bot and Telegram Analytics Bot integrations to enable this feature.",
    buttonText:
      buttonText ||
      formatMessage({
        id: "global.btn.integrate",
      }),
    onClick: onClick || null,
    showButton: showButton || pagePermission("integration").canEdit,
  };

  const campaignWording = {
    img: img || "campaign",
    title: title || "No trackings found",
    description:
      description ||
      formatMessage({
        id: "emptyState.attributionNeedTrackingTag.description",
      }),
    buttonText:
      buttonText ||
      formatMessage({ id: "emptyState.campaignNeedTrackingTag.btn" }),
    onClick: onClick || null,
    showButton: showButton || pagePermission("campaign").canEdit,
  };

  const wordingMap = {
    integrate: integrateWording,
    tracking: trackingWording,
    campaign: campaignWording,
  };

  const {
    img: mappedImg,
    title: mappedTitle,
    description: mappedDescription,
    buttonText: mappedButtonText,
    onClick: mappedOnClick,
    showButton: mappedShowButton,
  } = wordingMap[type];

  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: height || "100%",
        ...sx,
      }}>
      {backgroundImg && (
        <Box
          component="img"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
          src={require(`assets/img/emptyState/bgImg/${backgroundImg}.png`)}
          alt="empty state background"
        />
      )}
      <Box
        sx={{
          position: backgroundImg ? "absolute" : "relative",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}>
        <Box
          sx={{
            zIndex: 1,

            width: "302px",
            textAlign: "center",
            margin: "0 auto",
            fontSize: "14px",
            lineHeight: "normal",
          }}>
          <img src={require(`assets/img/emptyState/img/${mappedImg}.png`)} />
          <Box mt="12px" fontWeight={700} color="#555">
            {mappedTitle}
          </Box>
          <Box mt="8px" color="#777">
            {mappedDescription}
          </Box>
          {mappedShowButton && (
            <Button sx={{ mt: "16px" }} onClick={mappedOnClick || (() => {})}>
              {mappedButtonText}
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
}
